import DeliveryInstructions from "./DeliveryInstructions";

export default DeliveryInstructions;
